import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import { featuresClient } from 'src/apollo-clients'

export const GetFeaturesHOC = graphql(
  gql`
    query getFeaturesByAccount($accountId: Int!) {
      getFeaturesByAccount(accountId: $accountId) {
        code
        name
      }
    }
  `,
  {
    skip: (props: any) => !props.account && !props.accountId,
    options: (props: any) => ({
      client: featuresClient,
      variables: {
        accountId: (props.account && props.account.id) || props.accountId
      }
    }),
    props: (props: any) => {
      if (props.data && !props.data.loading) {
        return {
          features: props.data.getFeaturesByAccount,
          featuresLoading: false
        }
      }
      return {
        features: undefined,
        featuresLoading: true
      }
    }
  }
)
